import useAuth from 'auth/provider/useAuth';
import {UserSettings} from 'auth/types/UserSettings';

const useLocalUserSettings = (): UserSettings => {
  const {isLoggedIn, userSettings} = useAuth();
  return isLoggedIn ? userSettings : ({} as UserSettings);
};

export default useLocalUserSettings;
